import { FC } from 'react';
import { FaChevronDown } from 'react-icons/fa6';
import { LiaCheckDoubleSolid } from 'react-icons/lia';
import { useTheme } from 'styled-components';

import { Typography } from '../../../../designComponents';
import { CardContainer, PlansCardStyled } from './style';

interface PlansCardPropsType {
  onClick: (id: number) => void;
  seeAll: number[] | null;
  setSeeAll: React.Dispatch<React.SetStateAction<number[]>>;
  setPricePlan: React.Dispatch<React.SetStateAction<string>>;
  plansData: {
    _id: string;
    createdBy: string;
    title: string;
    price: string;
    priceDenom: string;
    stripeProductId: string;
    stripePriceId: string;
    isRecurring: boolean;
    isActive: boolean;
    planType: string;
    planDescription: {
      title: string;
      description: string;
      _id: string;
    }[];
    notes: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  }[];
  singlePricePlan: string;
  jobId?: string;
}
const PlansCard: FC<PlansCardPropsType> = ({
  onClick,
  seeAll,
  setSeeAll,
  setPricePlan,
  plansData,
  singlePricePlan,
}) => {
  const theme = useTheme();
  return (
    <CardContainer>
      {plansData.map((item, idx) => (
        <div
          key={idx}
          onClick={() => {
            setPricePlan(item._id);
          }}
          role="button"
          style={{ cursor: 'pointer' }}
        >
          <PlansCardStyled
            style={{
              border:
                singlePricePlan === item._id
                  ? `2px solid ${theme.colors.secondary}`
                  : '',
            }}
          >
            <div className="main-text">
              <div style={{ height: '57px' }}>
                <Typography
                  style={{
                    fontWeight: 600,
                    fontSize: '16px',
                    lineHeight: '19.36px',
                    marginTop: '30px',
                    color: theme.colors.landingSecondaryText,
                  }}
                >
                  {item.title}
                </Typography>
              </div>
              <Typography
                style={{
                  fontWeight: 600,
                  fontSize: '30px',
                  lineHeight: '45px',
                  color: theme.colors.primary,
                }}
              >
                € {item.price}{' '}
                {item.isRecurring ? (
                  <span
                    style={{
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '25px',
                      color: theme.colors.darkText,
                    }}
                  >
                    / Per Printout
                  </span>
                ) : (
                  ''
                )}
              </Typography>
              <Typography
                style={{
                  color: theme.colors.darkText,
                  fontWeight: 500,
                  fontSize: '14px',
                  lineHeight: '25px',
                  textAlign: 'start',
                }}
              >
                {item.notes}
              </Typography>
            </div>
            {!seeAll?.includes(idx) ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                }}
                role="button"
                onClick={() => onClick(idx)}
              >
                <Typography>See all</Typography> <FaChevronDown />
              </div>
            ) : (
              ''
            )}
            {seeAll?.includes(idx) ? (
              <div className="merits">
                {item.planDescription.map((merit, i) => (
                  <div className="merits-icon" key={i}>
                    <LiaCheckDoubleSolid
                      color={theme.colors.landingSecondaryText}
                      size={16}
                    />
                    <Typography>{merit.description}</Typography>
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}

            {seeAll?.includes(idx) ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                }}
                role="button"
                onClick={() => setSeeAll(seeAll.filter((prev) => prev !== idx))}
              >
                <Typography>See less</Typography>{' '}
                <FaChevronDown style={{ rotate: '180deg' }} />
              </div>
            ) : (
              ''
            )}
          </PlansCardStyled>
        </div>
      ))}
    </CardContainer>
  );
};

export default PlansCard;
